<template>
	<div class="donation-source card-component px30 pt-8 flex flex-col">
		<template v-if="processHandler === 'editCard'">
			<CardItem :card="card" :index="cardIndex" :edit="true" @actionWithCard="actionWithCard" :clickHandler="back" />
		</template>
		<template v-else-if="processHandler === 'addCard'">
			<button type="button" class="btn-empty-wrapper mr-5 mb-10" @click="back">
				<Close icon="back" />
			</button>
			<!--            <AuthorizeInfo @goNextCardProcess="back" />-->
			<AddCard :cards-count="cardsCount" @goNextCardProcess="back" @actionWithCard="actionWithCard" />
		</template>
		<template v-else>
			<button type="button" class="btn-empty-wrapper mr-5" @click="clickHandler">
				<Close icon="back" />
			</button>
			<h3 class="page-title color-text text-left text-28 text-text mt-5 tracking-tight leading-tight mb-2">
				<span class="text-primary">{{ $t('Donation') }}</span>
				<span class="text-secondary">{{ $t('Source') }}</span>
			</h3>
			<p class="tracking-normal text-text page-subtitle mb-3">
				{{ $t('Tap card to Edit or Delete.') }}
				 
			</p>
			<p class="tracking-normal text-text page-subtitle mb-5">
				{{ $t('Add the card(s) that are linked to your financial institution connected.') }}
			</p>

			<h3 class="text-red-500" v-if="$getState('isCardDeclined')"> Please chose (set default) another card, otherwise create new one !!! </h3>

			<ul class="card-list">
				<li v-for="(card, index) in cards" :key="index">
					<CardItem
						:card="card"
						:index="index"
						:edit="false"
						@actionWithCard="actionWithCard"
						:clickHandler="back"
						type="stripe"
					/>
				</li>
			</ul>
			<button
				v-ripple
				type="button"
				class="card-add-card flex flex-col justify-center items-center text-text leading-5 mb-7"
				@click="processHandler = 'addCard'"
			>
				<span class="text-36 block mb-2">+</span
				><span class="text-14 block font-bold">{{ $t('Add another card') }}</span>
			</button>
		</template>
	</div>
</template>

<script>
import Close from '../UI/Close';
import CardItem from './CardItem';
import AddCard from '../Card/AddCard';
import AuthorizeInfo from '../Card/AuthorizeInfo';
export default {
	name: 'DonationSource',

	components: { AuthorizeInfo, AddCard, CardItem, Close },

	props: ['clickHandler'],

	data: function() {
		return {
			cards: [],
			cardsCount: null,
			processHandler: '',
			card: {},
			cardIndex: '',
		};
	},

	mounted() {
		this.getListCards();
	},

	methods: {
		deleteCard: function(index) {
			this.$http.post('user/deletecard', { payment_method_id: index }).then((res) => {
				if (res && res.status !== undefined && res.status) {
					this.$store.commit('setCardDeclined', null)
					this.back();
					this.getListCards();
				}
			});
		},
		editCard: function(index) {
			this.$http.post('user/editcard', { payment_method_id: index }).then((res) => {
				if (res && res.status !== undefined && res.status) {
					this.getListCards();
				}
			});
		},
		saveDefaultCard: function(index) {
			this.$http.post('user/defaultcard', { payment_method_id: index }).then((res) => {
				if (res && res.status !== undefined && res.status) {
					this.back();
					this.getListCards();
				}
			});
		},
		savePosCard: function(index) {
			this.$http.post('user/poscard', { pos_id: index }).then((res) => {
				if (res && res.status !== undefined && res.status) {
					this.back();
					this.getListCards();
				}
			});
		},
		editCardHandler: function(card, index) {
			this.processHandler = 'editCard';
			this.card = card;
			this.cardIndex = index;
		},
		actionWithCard: function(obj) {
			switch (obj.action) {
				case 'openEdit':
					this.editCardHandler(obj.card, obj.index);
					break;
				case 'saveDefault':
					this.saveDefaultCard(obj.index);
					break;
				case 'savePos':
					this.savePosCard(obj.index);
					break;
				case 'delete':
					this.deleteCard(obj.index);
					break;
				case 'edit':
					this.editCard();
					break;
				case 'update':
					if(this.$getState('isCardDeclined')) this.deleteCard(this.$getState('isCardDeclined'))
					this.back();
					this.getListCards();
					break;
				default:
					return false;
			}
		},
		back: function(value) {
			this.processHandler = '';
			this.card = [];
			this.cardIndex = '';
			if (value === 'authorize' || value === 'addAnotherCard') {
				this.getListCards();
			}
		},
		getListCards: function() {
			this.cards = {};
			this.$http.get('user/listcard').then((res) => {
				if (res && res.status !== undefined && res.status) {
					this.cards = !!res.data.card_data ? res.data.card_data : {};

					if (this.$isEmptyObj(this.cards)) {
						this.$toastr.e(this.$t('Donations will be stopped'));
					}
				}
				const keys = Object.keys(this.cards)
				this.cardsCount = keys.length

				if ((res && res.status !== undefined && !res.status) || (this.$getState('isCardDeclined') &&  this.cardsCount <= 1 )) {
					this.processHandler = 'addCard';
				}
			});
		},
	},
};
</script>
